import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Download, UserPlus, Users } from 'lucide-react';

const STEP_ICONS = [Download, UserPlus, Users];

export default function HowItWorks() {
  const { t } = useLanguage();
  const steps = t('howItWorks.steps');

  return (
    <section id="how-it-works" className="py-24 sm:py-32 bg-[#003d33]" data-testid="how-it-works-section">
      <div className="container mx-auto px-6 lg:px-12">
        {/* Header */}
        <div className="text-center max-w-2xl mx-auto mb-20">
          <span className="text-xs uppercase tracking-[0.2em] font-bold text-[#E31C25] block mb-4">
            {t('howItWorks.label')}
          </span>
          <h2
            className="text-3xl sm:text-4xl lg:text-5xl tracking-tight font-bold text-white"
            style={{ fontFamily: 'Outfit, sans-serif' }}
            data-testid="how-it-works-title"
          >
            {t('howItWorks.title')}
          </h2>
        </div>

        {/* Steps */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-12" data-testid="how-it-works-steps">
          {Array.isArray(steps) && steps.map((step, i) => {
            const Icon = STEP_ICONS[i];
            return (
              <div
                key={i}
                className="relative group"
                data-testid={`how-it-works-step-${i}`}
              >
                {/* Step Number */}
                <div className="text-[7rem] font-black text-white/[0.04] absolute -top-8 -left-2 leading-none select-none" style={{ fontFamily: 'Outfit, sans-serif' }}>
                  {String(i + 1).padStart(2, '0')}
                </div>

                <div className="relative z-10">
                  <div className="w-14 h-14 rounded-2xl bg-white/[0.06] border border-white/[0.08] flex items-center justify-center mb-6 group-hover:bg-white/10 transition-colors">
                    <Icon className="w-6 h-6 text-white/80" />
                  </div>
                  <h3
                    className="text-xl font-bold text-white mb-3"
                    style={{ fontFamily: 'Outfit, sans-serif' }}
                  >
                    {step.title}
                  </h3>
                  <p className="text-zinc-400 leading-relaxed">
                    {step.description}
                  </p>
                </div>

                {/* Connector line (hidden on last) */}
                {i < 2 && (
                  <div className="hidden md:block absolute top-7 left-[calc(100%+1rem)] w-[calc(100%-2rem)] h-px bg-white/10" />
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
